import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Typography,
  Drawer,
  Hidden,
  Breadcrumbs,
  Link,
  Box,
  BottomNavigation,
  BottomNavigationAction,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';
import {
  dashboard3DrawersIconsPropTypes,
  drawerRoutesPropTypes,
  d3dPopoverMenusPropTypes,
  defaultD3dPopoverMenusPropTypes,
} from '../dashboard-3-drawers/d3d-prop-types';
import D3DDrawer from '../dashboard-3-drawers/D3DDrawer';
import seedLogo from '../../images/logo.svg';
import DDBTopAppBar from './DDBTopAppBar';
import MyAvatar from '../../widgets/avatar/MyAvatar';
import { AppState } from '../../state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER } from '../../state/seed-states';
import { APP_STATE_ACTION_TYPE_RAFFLESIA_USER } from '../../../rafflesia-app/state/rafflesia-states';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.background.default,
  },
  avatarActive: {
    border: `2px solid ${theme.palette.primary.main}`,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  toolbar: theme.mixins.toolbar,
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
  },
  drawerPaper: {
    width: drawerWidth,
    // backgroundImage: `url(${Image})`,
    // backgroundPosition: "right bottom",
    // backgroundRepeat: "no-repeat",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    width: theme.spacing(7) + 1,
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  main: {
    flexGrow: 1,
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: (props) => (props.usePaddingContent ? theme.spacing(3) : 0),
    flexGrow: 1,
  },
  bottomNavMixin: {
    height: 56,
  },
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
  },
}));

const DashboardDrawerBottomNav = (props) => {
  const {
    children,
    AuthenticationRepository,

    titleId,
    icons,
    routes,
    isLoading,
    usePaddingContent,
    defaultOpenDrawer,
    applicationName,
    logo,
    breadcrumbs,
    popoverMenus,
    bottomNavMenus,
  } = props;
  const classes = useStyles({ usePaddingContent });
  const location = useLocation();

  const { state } = React.useContext(AppState);

  const user = state[APP_STATE_ACTION_TYPE_USER];
  const userRafflesia = state[APP_STATE_ACTION_TYPE_RAFFLESIA_USER];
  let avatar;
  let profileTitle;
  let username;
  if (user) {
    avatar = user.avatar.avatar;
    profileTitle = user.avatar.title;
    username = user.user.uid;
  }
  if (userRafflesia) {
    username = userRafflesia.username;
  }
  const accountPath = `/user/${username}`;

  const [open, setOpen] = React.useState(defaultOpenDrawer);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  let bottomNavActiveIndex = -1;
  let accountMenuIndex = -1;
  let acccountMenuActive = false;
  bottomNavMenus.forEach((menu, i) => {
    if (menu.path === location.pathname) {
      bottomNavActiveIndex = i;
    }
    if (menu.type === 'account') {
      accountMenuIndex = i;
    }
  });
  if (bottomNavActiveIndex === -1 && accountMenuIndex !== -1) {
    bottomNavActiveIndex = accountMenuIndex;
    acccountMenuActive = true;
  }

  return (
    <div className={classes.root}>
      <DDBTopAppBar
        AuthenticationRepository={AuthenticationRepository}
        isLoading={isLoading}
        onDrawerToggle={handleDrawerToggle}
        onDrawerToggleMobile={handleDrawerMobileToggle}
        icons={icons}
        titleId={titleId}
        logo={logo}
        applicationName={applicationName}
        popoverMenus={popoverMenus}
        popoverProfilePath={accountPath}
      />
      <nav aria-label="mailbox folders">
        <Hidden xsDown implementation="css">
          <Drawer
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
            classes={{
              paper: clsx(classes.drawerPaper, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              }),
            }}
            variant="permanent"
            open={open}
          >
            <D3DDrawer
              routes={routes}
              logo={logo}
              applicationName={applicationName}
              useTooltip={!open}
              icons={icons}
              showNested={open}
            />
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.main}>
        <div className={classes.toolbar} />
        {
          breadcrumbs.length <= 0 ? '' : (
            <Box pt={1} pl={3} pr={3}>
              <Breadcrumbs aria-label="breadcrumb">
                {
                  breadcrumbs.map((bread) => {
                    if (bread.href) {
                      return (
                        <Link
                          key={`D3D-breadcrumb-${bread.id}`}
                          color="inherit"
                          href={bread.href}
                        >
                          <Typography variant="subtitle2">
                            {
                              bread.titleId ? (
                                <FormattedMessage id={bread.titleId} />
                              ) : bread.title
                            }
                          </Typography>
                        </Link>
                      );
                    }
                    return (
                      <Typography
                        key={`D3D-breadcrumb-${bread.id}`}
                        variant="subtitle2"
                        color="textPrimary"
                      >
                        {
                          bread.titleId ? (
                            <FormattedMessage id={bread.titleId} />
                          ) : bread.title
                        }
                      </Typography>
                    );
                  })
                }
              </Breadcrumbs>
            </Box>
          )
        }
        <div className={classes.content}>
          {children}
          <div className={classes.bottomNavMixin} />
        </div>
        <Hidden smUp>
          <BottomNavigation className={classes.bottomNav} value={bottomNavActiveIndex} showLabels>
            {
              bottomNavMenus.map((menu) => {
                const isAccount = menu.type === 'account';
                return (
                  <BottomNavigationAction
                    key={`bottom-nav-menu-${menu.labelId}`}
                    href={!isAccount ? menu.path : accountPath}
                    label={<FormattedMessage id={menu.labelId} />}
                    icon={!isAccount ? <menu.Icon /> : (
                      <MyAvatar
                        className={clsx({
                          [classes.avatarActive]: acccountMenuActive,
                        })}
                        size={24}
                        src={avatar}
                        name={profileTitle}
                        alt={profileTitle}
                      />
                    )}
                  />
                );
              })
            }
          </BottomNavigation>
        </Hidden>
      </main>
    </div>
  );
};

DashboardDrawerBottomNav.propTypes = {
  children: PropTypes.node.isRequired,
  titleId: PropTypes.string.isRequired,
  AuthenticationRepository: PropTypes.func.isRequired,

  routes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
  isLoading: PropTypes.bool,
  usePaddingContent: PropTypes.bool,
  defaultOpenDrawer: PropTypes.bool,
  applicationName: PropTypes.string.isRequired,
  logo: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      titleId: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
  popoverMenus: d3dPopoverMenusPropTypes,
  bottomNavMenus: PropTypes.arrayOf(
    PropTypes.shape({
      Icon: PropTypes.object,
      labelId: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
};

DashboardDrawerBottomNav.defaultProps = {
  routes: [],
  icons: seedDashboard3DrawersIcons,
  isLoading: false,
  usePaddingContent: true,
  defaultOpenDrawer: true,
  logo: seedLogo,
  breadcrumbs: [],
  popoverMenus: defaultD3dPopoverMenusPropTypes,
  bottomNavMenus: [],
};

export default DashboardDrawerBottomNav;
